// extracted by mini-css-extract-plugin
export default {"footer":"K_T","row":"K_dl","menu-column":"K_dm"};